﻿window.translatedLabels = function () {

    var titleDialogUnSavedChanges   = "";
    var contentDialogUnSavedChanges = "";

    return {
        initialize: function (translatedTitleDialogUnSavedChanges,
            translatedContentDialogUnSavedChanges) {

            titleDialogUnSavedChanges = translatedTitleDialogUnSavedChanges;
            contentDialogUnSavedChanges = translatedContentDialogUnSavedChanges;

        },

        getTitleDialogUnSavedChanges: function () {
            return titleDialogUnSavedChanges;
        },

        getContentDialogUnSavedChanges: function () {
            return contentDialogUnSavedChanges;
        }
    }
}();